import { type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import { WantedStatusLabel } from "@clientFrontend/features/publication/components/WantedStatusLabel";
import { ApprovalStatusLabel } from "@clientFrontend/features/publication/components/ApprovalStatusLabel";
import * as styles from "./styles.css";

type ShopContent = {
  id: number;
  shopId: number;
  name: string;
  address: string;
  approvalStatus: "none" | "pending" | "approved" | "remand";
  wantedStatus: "notApproved" | "inWanted" | "notInWanted";
  urls: {
    showUrl: string;
    editUrl: string;
    cancelPendingUrl: string;
    closeUrl: string;
    orderPrevUrl: string | null;
    orderNextUrl: string | null;
    destroyDraftUrl: string;
  };
};

type Props = {
  shopContent: ShopContent;
  hasClientShopAuth: boolean;
  canEdit: boolean;
  tabIsAll: boolean;
};

export const ShopTableItem: FC<Props> = ({ shopContent, hasClientShopAuth, canEdit, tabIsAll }) => (
  <>
    {tabIsAll && (
      <td className={styles.sort}>
        <div className={styles.sortButtonContainer}>
          {shopContent.urls.orderPrevUrl ? (
            <a
              href={shopContent.urls.orderPrevUrl}
              className={styles.sortButton.active}
              data-method="put"
            >
              <Icon name="arrow-bold-up" />
            </a>
          ) : (
            <span className={styles.sortButton.inactive}>
              <Icon name="arrow-bold-up" />
            </span>
          )}
          {shopContent.urls.orderNextUrl ? (
            <a
              href={shopContent.urls.orderNextUrl}
              className={styles.sortButton.active}
              data-method="put"
            >
              <Icon name="arrow-bold-down" />
            </a>
          ) : (
            <span className={styles.sortButton.inactive}>
              <Icon name="arrow-bold-down" />
            </span>
          )}
        </div>
      </td>
    )}
    <td className={styles.status}>
      {shopContent.wantedStatus !== "notApproved" && (
        <WantedStatusLabel status={shopContent.wantedStatus} />
      )}
      <br />
      <ApprovalStatusLabel approvalStatus={shopContent.approvalStatus} />
    </td>
    <td className={styles.description}>
      <span className={styles.shopId}>{shopContent.shopId}</span>
      <p className={styles.name}>{shopContent.name}</p>
    </td>
    <td className={styles.address}>{shopContent.address}</td>
    <td className={styles.actions}>
      {canEdit && shopContent.approvalStatus !== "pending" ? (
        <a className={styles.actionLink} href={shopContent.urls.editUrl}>
          <Icon name="edit" />
          編集
        </a>
      ) : (
        <span className={styles.actionLinkDisabled}>
          <Icon name="edit" />
          編集
        </span>
      )}
      <a className={styles.actionLink} href={shopContent.urls.showUrl}>
        <Icon name="add-more" />
        詳細
      </a>
      {shopContent.approvalStatus === "pending" && (
        <a
          className={styles.actionLink}
          href={shopContent.urls.cancelPendingUrl}
          data-method="patch"
          data-confirm="申請を取り消します。新規店舗の場合、求人に設定されている【給与・勤務時間】が削除されます。本当によろしいですか？"
        >
          <Icon name="cross-bold" />
          申請取り消し
        </a>
      )}
      {shopContent.approvalStatus === "none" && (
        <a
          className={styles.actionLink}
          href={shopContent.urls.destroyDraftUrl}
          data-confirm="下書きを削除しますか？"
          data-method="delete"
        >
          <Icon name="deletion" />
          下書き削除
        </a>
      )}
      {tabIsAll && hasClientShopAuth && canEdit && shopContent.approvalStatus !== "pending" && (
        <a className={styles.actionLink} href={shopContent.urls.closeUrl}>
          <Icon name="deletion" />
          閉店申請
        </a>
      )}
      {tabIsAll && hasClientShopAuth && !(canEdit && shopContent.approvalStatus !== "pending") && (
        <span className={styles.actionLinkDisabled}>
          <Icon name="deletion" />
          閉店申請
        </span>
      )}
    </td>
  </>
);
